import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Auto-update guard. A long-open dashboard tab keeps running its OLD JS bundle
// after a deploy (typing in a search box doesn't re-fetch JS), so a fixed bug can
// look unfixed until the page is fully reloaded. Poll the server's index.html for
// the current content-hashed bundle name; when it differs from the one this tab
// loaded, show a one-click "update" banner. No framework deps, fully self-contained,
// never throws into the app.
(function watchForNewBuild() {
  try {
    const loaded = document.querySelector('script[src*="/static/js/main."]');
    const mine = ((loaded && loaded.src) || '').match(/main\.[a-z0-9]+\.js/);
    if (!mine) return;
    const myBundle = mine[0];
    let banner = null;
    const showBanner = () => {
      if (banner || document.getElementById('app-update-banner')) return;
      banner = document.createElement('div');
      banner.id = 'app-update-banner';
      banner.textContent = '🔄 A new version of the dashboard is available — click to update';
      banner.style.cssText =
        'position:fixed;top:0;left:0;right:0;z-index:2147483647;background:#0F2746;color:#fff;' +
        'padding:11px 16px;text-align:center;font:600 14px system-ui,-apple-system,sans-serif;' +
        'cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.25)';
      banner.onclick = () => window.location.reload();
      document.body.appendChild(banner);
    };
    const check = async () => {
      try {
        const res = await fetch('/?_v=' + Date.now(), { cache: 'no-store' });
        if (!res.ok) return;
        const html = await res.text();
        const live = html.match(/main\.[a-z0-9]+\.js/);
        if (live && live[0] !== myBundle) showBanner();
      } catch (_) { /* offline / transient — ignore */ }
    };
    setInterval(check, 90 * 1000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
  } catch (_) { /* never break the app over this */ }
})();
